import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";
import { useStoreLocatorContext } from "../../../../components/StoreLocator";
import { useLocale } from "../../../../providers/useLocale";
import { getCurrentDayShopStatus, getDayOfWeekMondayFirst, getNextDayOpenTime, } from "../StoreLocatorCard/components/StoreLocatorShopSchedule/utils";
import { StoreLocatorOpeningStatus } from "../StoreLocatorOpeningStatus/StoreLocatorOpeningStatus";
import { StoreLocatorAvailableProducts } from "./components";
import cardStyles from "./../StoreLocatorCard/StoreLocatorCard.module.scss";
import styles from "./StoreLocatorCardV2.module.scss";
export const StoreLocatorCardV2 = ({ store, className, isListView, mapWrapperRef, storeDetailsPageUrl, }) => {
    const { isOpeningHoursEnabled, isOpeningHoursBreaksEnabled, isAvailableDevicesEnabled, isAvailableSticksEnabled, storeDetailsPageTarget, } = useStoreLocatorContext();
    const isOpeningHoursBlockVisible = isOpeningHoursEnabled && !!store.opening_hours?.length;
    const isAvailableProductsVisible = (isAvailableDevicesEnabled || isAvailableSticksEnabled) && !!store.product_attributes?.length;
    const locale = useLocale();
    const { days, time_zone } = ["days", "time_zone"].reduce((acc, key) => {
        if (store.opening_hours?.[0]) {
            acc[key] = store.opening_hours[0][key];
        }
        return acc;
    }, { days: null, time_zone: null });
    const dayOfWeekMondayFirst = getDayOfWeekMondayFirst();
    const currentDayShopSchedule = days?.[dayOfWeekMondayFirst];
    const nextDayOpenTime = useMemo(() => (days?.length ? getNextDayOpenTime(days) : days), [days]);
    const { shopOpeningStatus, shopOpeningHours } = useMemo(() => nextDayOpenTime
        ? getCurrentDayShopStatus(currentDayShopSchedule, time_zone, isOpeningHoursBreaksEnabled, isListView, nextDayOpenTime)
        : { shopOpeningHours: undefined, shopOpeningStatus: undefined }, [currentDayShopSchedule, time_zone, isOpeningHoursBreaksEnabled, isListView, nextDayOpenTime]);
    const handleOnClick = () => {
        const currentUrl = window.location.origin;
        const newUrl = `${currentUrl}/${locale}/${storeDetailsPageUrl}`.replace(/([^:]\/)\/+/g, "$1");
        if (storeDetailsPageTarget === "_blank") {
            window.open(newUrl, "_blank");
        }
        else {
            window.location.replace(newUrl);
        }
    };
    if (!store) {
        return null;
    }
    const CardContent = (_jsxs("article", { "data-testid": "storeLocatorCardV2", onClick: handleOnClick, rel: "noreferrer", className: classNames(cardStyles.resultCard, styles.resulCardV2, className, {
            [cardStyles.resultCardActive]: !isListView,
        }), children: [_jsxs("header", { children: [_jsx("p", { className: classNames(cardStyles.resultCardShopName, styles.resultCardShopName), children: store.StoreName }), _jsx(ChevronForwardIcon, { className: styles.storeCardChevron })] }), (isOpeningHoursBlockVisible || isAvailableProductsVisible) && (_jsxs("div", { className: classNames(cardStyles.cardInfoWrapper, styles.cardInfoWrapper, {
                    [cardStyles.cardInfoSingleView]: !isListView && !isOpeningHoursBlockVisible,
                }), children: [isOpeningHoursBlockVisible && shopOpeningStatus && shopOpeningHours && (_jsx(StoreLocatorOpeningStatus, { shopOpeningStatus: shopOpeningStatus, shopOpeningHours: shopOpeningHours, isNewStoreCardEnabled: true })), isAvailableProductsVisible && (_jsx(StoreLocatorAvailableProducts, { productAttributes: store.product_attributes, isListView: isListView }))] }))] }));
    if (mapWrapperRef?.current && !isListView) {
        return ReactDOM.createPortal(_jsx("div", { className: styles.cardLocatorMapWrapper, children: CardContent }), mapWrapperRef.current);
    }
    return CardContent;
};
//# sourceMappingURL=StoreLocatorCardV2.js.map